import { FabricObject, Transform as FabricTransform } from 'fabric';

export type ControlVisibility = { [k in FabricTransform['corner']]: boolean };

function useControlVisibility(element: FabricObject, controls: ControlVisibility | undefined) {
  element.setControlsVisibility(controls);
}

export default useControlVisibility;
